import { useVfm } from 'vue-final-modal';
import VersionsModal from '@/modules/viewer/components/modals/versions/VersionsModal.vue';
import { useModal } from '@/storybook/modal/useModal';

export const useVersionsModal = () => {
  const vfm = useVfm();

  const closeVersionsModal = () => {
    return vfm.closeAll();
  };

  const showVersionsModal = () => {
    const { open } = useModal(VersionsModal);
    return open();
  };

  return { closeVersionsModal, showVersionsModal };
};
